import { Instance, SnapshotIn, types } from 'mobx-state-tree';

const UserAnswerItem = types
	.model('UserAnswerItem', {
		id: types.optional(types.number, 0),
		onboarding_quiz_slide_id: types.maybeNull(types.number),
		value: types.optional(types.string, ''),
		is_ending: types.maybeNull(types.boolean),
		is_correct: types.maybeNull(types.boolean),
		sort_id: types.maybeNull(types.number),
		created_at: types.maybeNull(types.string),
		updated_at: types.maybeNull(types.string),
		deleted_at: types.maybeNull(types.string),
		is_selected: types.maybeNull(types.boolean),
	})
	.volatile(() => ({
		loading: false,
	}))
	.actions(() => ({}));

export default UserAnswerItem;

export interface IUserAnswerItemModel extends Instance<typeof UserAnswerItem> {}
export type IUserAnswerItemSnapshotIn = SnapshotIn<typeof UserAnswerItem>;
